import React from 'react';
import { Component } from 'react';
import ConfirmationBlock from '../contents/confirmation/Confirmation';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';

class ConfirmationCont extends Component {
    render() {
        let { containerClass, handleSubmit, values, getData } = this.props;

        return (
            <div className={'content-container confirmation-container ' + containerClass}>
                <ConfirmationBlock values={values} getData={getData} handleSubmit={handleSubmit} />
            </div>
        );
    }
}

ConfirmationCont.defaultProps = InitialState().confirmationSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        containerClass: _state.confirmationSection.containerClass,
        values: _state.confirmationSection.values
    }
}

const ConfirmationContainer = connect(
    mapStateToProps
)(ConfirmationCont)

export default ConfirmationContainer
